import { isEditorDocumentEmpty } from './is-editor-document-empty';

export const serializeEditorDocument = (
	doc: { content?: readonly unknown[] } | null | undefined,
): string => {
	// Treat an empty or whitespace-only document as no value, so a comment /
	// description / justification made of only spaces is never stored.
	if (!doc?.content?.length || isEditorDocumentEmpty(doc)) {
		return '';
	}
	return JSON.stringify(doc);
};
